let Loader = require("./Loader");

const _tz = moment.tz.guess() || "GMT";
const _loader = new Loader();

const _hms = (millis) => {
  let t = Math.round(Math.max(0, millis) / 1000) * 1000;
  let h = t / 3600000;
  let m = t / 60000 % 60;
  let s = t / 1000 % 60;

  return [h, m, s];
};

let Format = {
  setLocale(locale) {
    let lang = locale.substr(0, 2).toLowerCase();
    let url = `./vendor/mc/moment/${moment.version}/locale/${lang}.js`;
    let loader = lang === "en" ? Promise.resolve() : _loader.load(url);

    return loader.then(function () {
      moment.locale(locale);
    });
  },
  timezonesByRegion() {
      // Improved listing with optgroups aggregating TZs
      let boundaries = {
          "US/Alaska": "USA / Canada",
          "Asia/Seoul": "Asia / Pacific",
          "Europe/Amsterdam": "Europe",
          "Etc/GMT+12": "Etc"
      };
      let result = new Map(); // ordered
      let current;
      for (const tz of this.timezones()) {
          if (tz in boundaries) {
              current = boundaries[tz];
              result.set(current, []);
          }
          result.get(current).push(tz);
      }
      return result;
  },
  timezones() {
    return [
// https://github.com/vvo/tzdb
// https://www.iana.org/time-zones

// US/Canada
      "US/Alaska",
      "US/Aleutian",
      "US/Arizona",
      "US/Central",
      "US/East-Indiana",
      "US/Eastern",
      "US/Hawaii",
      "US/Indiana-Starke",
      "US/Mountain",
      "US/Pacific",
      "US/Samoa",
      "Canada/Atlantic",
      "Canada/Central",
      "Canada/Eastern",
      "Canada/Mountain",
      "Canada/Newfoundland",
      "Canada/Pacific",
      "Canada/Saskatchewan",
      "Canada/Yukon",
// Japan + MDSOL locations
// https://en.wikipedia.org/wiki/Time_in_China#IANA_time_zone_database
// https://www.timeanddate.com/time/zone/japan
// https://www.timeanddate.com/time/zone/singapore
// https://www.timeanddate.com/time/zone/south-korea
      "Asia/Seoul",
      "Asia/Shanghai",
      "Asia/Singapore",
      "Asia/Tokyo",
// Australia + New Zealand + Territories
// https://www.timeanddate.com/time/zone/new-zealand https://en.wikipedia.org/wiki/Time_in_New_Zealand
// https://www.timeanddate.com/time/zones/au https://en.wikipedia.org/wiki/Time_in_Australia
      "Australia/Adelaide",
      "Australia/Brisbane",
      "Australia/Broken_Hill",
      "Australia/Currie",
      "Australia/Darwin",
      "Australia/Eucla",
      "Australia/Hobart",
      "Australia/Lindeman",
      "Australia/Lord_Howe",
      "Australia/Melbourne",
      "Australia/Perth",
      "Australia/Sydney",
      "Indian/Christmas",  // AU
      "Indian/Cocos",      // AU
      "Pacific/Auckland",  // NZ
      "Pacific/Chatham",   // NZ
      "Pacific/Fakaofo",   // NZ (Tokelau)
      "Pacific/Niue",      // NZ
      "Pacific/Norfolk",   // AU
      "Pacific/Rarotonga", // NZ (Cook)
// Europe
      "Europe/Amsterdam",
      "Europe/Andorra",
      "Europe/Astrakhan",
      "Europe/Athens",
      "Europe/Belgrade",
      "Europe/Berlin",
      "Europe/Bratislava",
      "Europe/Brussels",
      "Europe/Bucharest",
      "Europe/Budapest",
      "Europe/Busingen",
      "Europe/Chisinau",
      "Europe/Copenhagen",
      "Europe/Dublin",
      "Europe/Gibraltar",
      "Europe/Guernsey",
      "Europe/Helsinki",
      "Europe/Isle_of_Man",
      "Europe/Istanbul",
      "Europe/Jersey",
      "Europe/Kaliningrad",
      "Europe/Kiev",
      "Europe/Kirov",
      "Europe/Lisbon",
      "Europe/Ljubljana",
      "Europe/London",
      "Europe/Luxembourg",
      "Europe/Madrid",
      "Europe/Malta",
      "Europe/Mariehamn",
      "Europe/Minsk",
      "Europe/Monaco",
      "Europe/Moscow",
      "Europe/Oslo",
      "Europe/Paris",
      "Europe/Podgorica",
      "Europe/Prague",
      "Europe/Riga",
      "Europe/Rome",
      "Europe/Samara",
      "Europe/San_Marino",
      "Europe/Sarajevo",
      "Europe/Saratov",
      "Europe/Simferopol",
      "Europe/Skopje",
      "Europe/Sofia",
      "Europe/Stockholm",
      "Europe/Tallinn",
      "Europe/Tirane",
      "Europe/Ulyanovsk",
      "Europe/Uzhgorod",
      "Europe/Vaduz",
      "Europe/Vatican",
      "Europe/Vienna",
      "Europe/Vilnius",
      "Europe/Volgograd",
      "Europe/Warsaw",
      "Europe/Zagreb",
      "Europe/Zaporozhye",
      "Europe/Zurich",
// Generic ETC entries
      "Etc/GMT+12",
      "Etc/GMT+11",
      "Etc/GMT+10",
      "Etc/GMT+9",
      "Etc/GMT+8",
      "Etc/GMT+7",
      "Etc/GMT+6",
      "Etc/GMT+5",
      "Etc/GMT+4",
      "Etc/GMT+3",
      "Etc/GMT+2",
      "Etc/GMT+1",
      "Etc/GMT",
      "Etc/GMT-1",
      "Etc/GMT-2",
      "Etc/GMT-3",
      "Etc/GMT-4",
      "Etc/GMT-5",
      "Etc/GMT-6",
      "Etc/GMT-7",
      "Etc/GMT-8",
      "Etc/GMT-9",
      "Etc/GMT-10",
      "Etc/GMT-11",
      "Etc/GMT-12",
      "Etc/GMT-13",
      "Etc/GMT-14"
     ];
  },

  date(date, tz, format) {
    let formats = {
      "short": "l",
      "long":  "ddd, MMM D, YYYY",
      "cal": "MMM YYYY",
      "compact": "M/D"
    };

    return moment(date).tz(tz || _tz).format(formats[format || "short"]);
  },

  time(date, tz, format) {
    let formats = {
      "short":   "h:mm A",
      "medium":  "h:mm:ss A",
      "long":    "h:mm:ss A z",
      "precise": "h:mm:ss.SSS"
    };

    return moment(date).tz(tz || _tz).format(formats[format || "medium"]);
  },

  datetime(date, tz) {
    return moment(date).tz(tz || _tz).format("l, h:mm:ss A z");
  },

  number(n, precision = 0) {
    return n.toLocaleString({}, { minimumFractionDigits: precision, maximumFractionDigits: precision });
  },

  percent(n, signed) {
    return (signed && n > 0 ? "+" : "") + Math.round(n * 100) + "%";
  },

  name(user, reverse) {
    let first = user.firstName || "...";
    let last = user.lastName || "...";

    return reverse ? [last, first].join(", ") : [first, last].join(" ");
  },

  duration(millis) {
    let f = (n, i) => (Math.floor(n) ? Math.floor(n) + "hms".charAt(i) : "");

    return _hms(millis).map(f).join(" ").trim() || "0";
  },

  interval(millis) {
    let f = (n) => ("0" + Math.floor(n)).substr(-2);

    return _hms(millis).map(f).join(":");
  },

  height(meters) {
    let inches = meters * 39.3701;

    let f = Math.floor(inches / 12);
    let i = Math.round(inches % 12);

    if (i === 12) {
      i = 0;
      f++;
    }

    return `${f}’ ${i}”`;
  },

  weight(kilos) {
    let lbs = Math.round(kilos * 2.20462);

    return `${lbs} lbs.`;
  },

  bmi(kilos, meters) {
    return (kilos / (meters ** 2)).toFixed(1);
  },

  filesize(bytes) {
    let power = 1;
    let unit = "KB";

    if (bytes >= 1024 ** 2) {
      power = 2;
      unit = "MB";
    }

    if (bytes >= 1024 ** 3) {
      power = 3;
      unit = "GB";
    }

    return (bytes / (1024 ** power)).toFixed(1) + " " + unit;
  },

  angle(degrees, precision = 0) {
    return degrees.toFixed(degrees % 1 === 0 ? 0 : precision) + "˚";
  },

  temperature(celciusDegrees, unit = "C", precision = 0) {
    let degrees = unit === "C" ? celciusDegrees : (celciusDegrees * 1.8) + 32;

    return degrees.toFixed(degrees % 1 === 0 ? 0 : precision) + "˚" + unit;
  }
};

module.exports = Format;
